<script setup>
  import { computed } from 'vue'

  import { useFieldValueRenderer } from '@/features/settingsManagement/fieldManagement/edit/plugin/useFieldRenderer.js'
  import { fieldCommonProps } from '@/features/settingsManagement/fieldManagement/edit/utils/fieldUtils.js'

  const props = defineProps({
    field: fieldCommonProps.field,
  })

  const { fieldRendererTemplateComponent } = useFieldValueRenderer()

  const isRequired = computed(() => props.field?.isCompulsory)
</script>

<template>
  <template v-if="fieldRendererTemplateComponent">
    <!-- TODO @ozer maybe we should pass extraData.label here? -->
    <component
      :is="fieldRendererTemplateComponent"
      :label="field.key"
      :is-required="isRequired"
      :data-field-key="field.key"
      :data-field-key-type="field.keyType"
      :data-field-id="field.id"
    >
      <slot />

      <div class="validation">
        <slot name="validation" />
      </div>
    </component>
  </template>

  <div
    v-else
    class="dynamic-field"
    :data-field-key="field.key"
    :data-field-key-type="field.keyType"
    :data-field-id="field.id"
  >
    <label>
      <slot name="label" />
    </label>
    <slot />

    <div class="validation">
      <slot name="validation" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .dynamic-field {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .validation {
    color: red;
    font-size: 0.8rem;
  }
</style>
